import usePrivateAxios from "@/common/api/usePrivateAxios"
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant"
import { Mapper } from "@/common/services/mapper"
import { MetaResponse } from "@/common/types/metaResponse"
import { keepPreviousData, useQuery } from "@tanstack/react-query"

type UseEstablishmentFlagsProps<T> = {
  filters?: {
    search?: string
  }
  mapper?: (data: any) => T,
}

export const useEstablishmentFlags = <T,>({
  filters: { search = '' } = {},
  mapper = Mapper.default<T>(),
}: UseEstablishmentFlagsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: ['establishmentFlags', search],
    queryFn: () => {
      return privateAxios.get('/establishment/flags', {
        params: {
          search
        }
      })
    },
    select: (data: { data: { data: any[], meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, ...rest }
}
